const TimerConstants = {
    winterOffset: "01:00",
    summerOffset: "02:00",
};
const DaysTimerConstants = {
    secondsInMinute: 60,
    secondsInHour: 60 * 60,
    secondsInDay: 24 * 60 * 60,
    lastDaysAsHoursCount: 2,
    selectors: {
        unit: (name) => `[data-timer-unit="${name}"]`,
        value: "[data-timer-value]",
        label: "[data-timer-label]",
    },
};
export class TimerCountdown {
    constructor(endDate, selector, dataset = {}) {
        this.element = null;
        this.endDate = endDate;
        this.selector = selector;
        this.options = this.getOptions(dataset);
    }
    getOptions(dataset) {
        return {
            showDays: dataset.timerShowDays === "true",
            lastDaysAsHours: dataset.timerLastDaysAsHours === "true",
        };
    }
    isDaysTimer() {
        return this.options.showDays || this.options.lastDaysAsHours;
    }
    init() {
        this.initDomElement();
        this.startTimer();
        this.interval = setInterval(() => { this.startTimer(); }, 1000);
    }
    initDomElement() {
        this.element = document.querySelector(this.selector);
    }
    startTimer() {
        if (this.isDaysTimer())
            return this.startDaysTimer();
        const { hours, minutes, seconds, theEnd } = this.getTimeUntil(this.endDate);
        if (theEnd)
            this.stopTimer();
        if (!this.element)
            return;
        this.element.innerHTML = `${hours}:${minutes}:${seconds}`;
    }
    stopTimer() {
        clearInterval(this.interval);
    }
    isWinterTime(today = new Date()) {
        const currentYear = today.getFullYear(), marchIndex = 2, octoberIndex = 9, lastSundayOfOctober = this.getLastSundayOfMonth(currentYear, octoberIndex + 1), lastSundayOfMarch = this.getLastSundayOfMonth(currentYear, marchIndex + 1);
        const winterStart = new Date(currentYear, octoberIndex, lastSundayOfOctober, 3), winterEnd = new Date(currentYear, marchIndex, lastSundayOfMarch, 2);
        return (today >= winterStart || today < winterEnd);
    }
    getLastSundayOfMonth(year, month) {
        const date = new Date(year, month, 0);
        date.setDate(date.getDate() - date.getDay());
        return date.getDate();
    }
    getTimeUntil(date) {
        const offset = this.isWinterTime() ? TimerConstants.winterOffset : TimerConstants.summerOffset, endTime = new Date(new Date(`${date}+${offset}`).toUTCString()).getTime(), userTime = new Date().getTime();
        const timeRemaining = endTime - userTime;
        if (timeRemaining <= 0)
            return { hours: '00', minutes: '00', seconds: '00', theEnd: true };
        const hours = Math.floor(timeRemaining / (1000 * 60 * 60)).toString().padStart(2, '0'), minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0'), seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000).toString().padStart(2, '0');
        return { hours, minutes, seconds, theEnd: false };
    }
    startDaysTimer() {
        const remainingSeconds = this.getRemainingSeconds(this.endDate);
        if (remainingSeconds <= 0)
            this.stopTimer();
        if (!this.element)
            return;
        this.updateDaysTimerElements(this.getTimeUnits(remainingSeconds));
    }
    getRemainingSeconds(date) {
        const offset = this.isWinterTime(new Date(date)) ? TimerConstants.winterOffset : TimerConstants.summerOffset, endTime = new Date(`${date}+${offset}`).getTime(), remainingSeconds = Math.floor((endTime - Date.now()) / 1000);
        return remainingSeconds > 0 ? remainingSeconds : 0;
    }
    getTimeUnits(remainingSeconds) {
        const { secondsInDay, secondsInHour, secondsInMinute, lastDaysAsHoursCount } = DaysTimerConstants, onlyHours = this.options.lastDaysAsHours && remainingSeconds <= lastDaysAsHoursCount * secondsInDay;
        return {
            days: onlyHours ? 0 : Math.floor(remainingSeconds / secondsInDay),
            hours: onlyHours
                ? Math.floor(remainingSeconds / secondsInHour)
                : Math.floor((remainingSeconds % secondsInDay) / secondsInHour),
            minutes: Math.floor((remainingSeconds % secondsInHour) / secondsInMinute),
            seconds: remainingSeconds % secondsInMinute,
        };
    }
    updateDaysTimerElements({ days, hours, minutes, seconds }) {
        const daysVisible = days > 0, daysState = daysVisible ? "visible" : "hidden";
        if (this.element && this.element.dataset.timerDays !== daysState)
            this.element.dataset.timerDays = daysState;
        this.updateUnit("days", days, daysVisible);
        this.updateUnit("hours", hours);
        this.updateUnit("minutes", minutes);
        this.updateUnit("seconds", seconds);
    }
    updateUnit(name, count, visible = true) {
        var _a;
        const { selectors } = DaysTimerConstants, unit = (_a = this.element) === null || _a === void 0 ? void 0 : _a.querySelector(selectors.unit(name));
        if (!unit)
            return;
        const valueElement = unit.querySelector(selectors.value), labelElement = unit.querySelector(selectors.label), value = count.toString(), label = this.getLabel(labelElement, count);
        unit.hidden = !visible;
        if (valueElement && valueElement.textContent !== value)
            valueElement.textContent = value;
        if (labelElement && label !== undefined && labelElement.textContent !== label)
            labelElement.textContent = label;
    }
    getLabel(labelElement, count) {
        var _a;
        const { labelOne, labelMany } = (_a = labelElement === null || labelElement === void 0 ? void 0 : labelElement.dataset) !== null && _a !== void 0 ? _a : {};
        return count === 1 ? (labelOne !== null && labelOne !== void 0 ? labelOne : labelMany) : (labelMany !== null && labelMany !== void 0 ? labelMany : labelOne);
    }
}
